export function validateProduct(product) {
    const errors = {};

    if (!product.name?.trim()) {
        errors.name = "Product name is required";
    }

    if (!product.categoryId) {
        errors.categoryId = "Category is required";
    }

    if (product.price === undefined || product.price === "" || product.price === null) {
        errors.price = "Price is required";
    } else if (isNaN(product.price) || parseFloat(product.price) < 0) {
        errors.price = "Price must be a valid positive number";
    }

    if (product.quantity === undefined || product.quantity === "" || product.quantity === null) {
        errors.quantity = "Quantity is required";
    } else if (isNaN(product.quantity) || parseInt(product.quantity) < 0) {
        errors.quantity = "Quantity must be a valid positive integer";
    }

    if (!product.images || product.images.length === 0) {
        errors.images = "At least one product image is required";
    } else if (product.images.length > 3) {
        errors.images = "Maximum of 3 images allowed";
    }

    return errors;
}

export function validateProducts(products) {
    const result = [];

    products.forEach((product, index) => {
        const errors = validateProduct(product);
        if (Object.keys(errors).length > 0) {
            result.push({ index, errors });
        }
    });

    return result;
}
